import React, { FunctionComponent } from 'react';
import AdminUsersPage from './AdminUsersPage';
import { useAppSelector } from '../../../hooks';
import { getConfigState } from '../../../store/ConfigSlice';
import { getAuthState } from '../../../store/AuthSlice';
import { checkUserPermission } from '../../../helper';
import NoAccessPageView from '../../../components/V2/Validations/NoAccessPageView';
import NoEditModePageView from '../../../components/V2/Validations/NoEditModePageView';
import { USER_PERMISSION_INDIVIDUALS } from '../../../store/V2/RolesSlice';

const Users: FunctionComponent = () => {
  // Store
  const configState = useAppSelector(getConfigState);
  const authState = useAppSelector(getAuthState);

  if (
    checkUserPermission(authState.user, {
      adminUsers: [USER_PERMISSION_INDIVIDUALS.ADMIN_USERS_VIEW],
    })
  ) {
    if (configState.adminEditMode) {
      return <AdminUsersPage />;
    }

    return <NoEditModePageView />;
  }

  return <NoAccessPageView />;
};

export default Users;
